(() => {
  if (window.latrandConsentReady) return;
  window.latrandConsentReady = true;
  const consentInputs = () => document.querySelectorAll('[data-form-privacy-required]');
  const unchecked = form => Array.from(consentInputs()).find(input => input.form === form && !input.checked);
  const formFor = element => element.form || document.getElementById(element.dataset.consentForm || element.getAttribute('form'));
  const sync = () => {
    document.querySelectorAll('[data-latrand-consent-controls]').forEach(group => {
      const form = document.getElementById(group.dataset.consentForm);
      const input = Array.from(document.querySelectorAll('[data-latrand-cart-consent]')).find(box => box.form === form);
      const locked = !input || !input.checked;
      if (group.disabled !== locked) group.disabled = locked;
      group.querySelectorAll('[data-latrand-consent-checkout]').forEach(button => {
        // Never clear disabled set by the native cart-empty/update logic.
        button.setAttribute('aria-disabled', String(locked || button.disabled));
      });
    });
    document.querySelectorAll('[data-latrand-consent-express]').forEach(group => {
      const form = document.getElementById(group.dataset.consentForm);
      const input = Array.from(document.querySelectorAll('[data-latrand-cart-consent]')).find(box => box.form === form);
      const locked = !input || !input.checked;
      group.hidden = locked;
      group.inert = locked;
      group.setAttribute('aria-hidden', String(locked));
    });
  };
  const stop = (event, input) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    input.setCustomValidity(input.dataset.requiredMessage || '');
    input.reportValidity();
    input.focus({preventScroll: false});
  };
  const guardCheckout = event => {
    const button = event.target instanceof Element ? event.target.closest('[data-latrand-consent-checkout]') : null;
    if (!button) return;
    const form = formFor(button);
    const input = unchecked(form);
    if (!form) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (input) stop(event, input);
  };
  // Izprati listens during capture before the theme's ordinary click handler.
  ['pointerup','mouseup','touchend','click'].forEach(type => window.addEventListener(type, guardCheckout, true));
  window.addEventListener('submit', event => {
    const input = unchecked(event.target);
    if (input) stop(event, input);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-form-privacy-required]')) return;
    event.target.setCustomValidity('');
    sync();
  });
  document.addEventListener('reset', () => queueMicrotask(sync));
  const observer = new MutationObserver(sync);
  const init = () => { sync(); observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
